export const Step = {
  ReviewSsn: 'ReviewSsn',
  Done: 'Done',
};
